import Card from "../card/Card";
import "./Service.css";
import pantalla from "../../assets/Pantalla.jpg";
import bateria from "../../assets/Bateria.jpg";
import pinCarga from "../../assets/pindecarga.jpg";
import altavoz from "../../assets/altavoz.jpg";
import auriculares from "../../assets/auriculares.jpg";
import otros from "../../assets/otros.jpg";

const Service = () => {
  return (
    <div className="service">
      <p id="subtitle">Tu celular como nuevo, sin vueltas</p>
      <h2 id="title-service">Reparamos tu celular rápido y con garantía</h2>
      <div className="box-service">
        <Card
          titleservice="Cambio de pantalla"
          image={pantalla}
          description={
            "Reemplazo de pantalla para celulares con repuestos de calidad, devolviendo imagen y tacto como nuevo. Servicio rápido, seguro y con garantía."
          }
        />
        <Card
          titleservice="Cambio de bateria"
          image={bateria}
          description={
            "Cambio de batería para celulares, mejorando la duración y rendimiento del equipo. Repuestos de calidad, servicio rápido y garantía incluida."
          }
        />
        <Card
          titleservice="Cambio de pin de carga"
          image={pinCarga}
          description={
            "Cambio de pin de carga para celulares, solucionando problemas de conexión y carga. Repuestos de calidad, servicio rápido y garantía incluida."
          }
        />
        <Card
          titleservice="Cambio de altavoz"
          image={altavoz}
          description={
            "Cambio de altavoz para celulares, recuperando un sonido claro y potente. Repuestos de calidad, servicio rápido y garantía incluida."
          }
        />
        <Card
          titleservice="Cambio de auriculares"
          image={auriculares}
          description={
            "Cambio de pin de auriculares para celulares, solucionando fallas de sonido al conectar tus audífonos. Repuestos de calidad, servicio rápido y garantía incluida."
          }
        />
        <Card
          titleservice="Y muchos más..."
          image={otros}
          description={
            "Y muchos más servicios para tu celular: diagnósticos, reparaciones generales y soluciones a medida. Atención rápida, repuestos de calidad y garantía en cada trabajo."
          }
        />
      </div>
    </div>
  );
};

export default Service;
